export enum VerificationType {
  Sms = 'Sms',
  Email = 'Email',
}

export enum VerificationStatus {
  Initial,
  Sending,
  Sent,
  Verifying,
  Error,
  Success,
}
